import React from "react";

export default ({title, breadcrumbs, children}) => {
   return <div style={{backgroundColor: "#FBFBFB"}}>
       <div className="mx-3 mx-md-5 pt-3">
        <div className="m-4 pl-2 border-bottom border-1 border-dark d-flex align-items-center">
            <div className="h1 font-weight-normal color-dark-blue flex-grow-1">{title}</div>
            <div className="flex-1">
                {breadcrumbs && breadcrumbs.length > 0 ? breadcrumbs.map(({text, link}) => {
                    if (link){
                        return <span className="font-weight-bold color-light-blue"><a className="text-decoration-none" href={link}>{text}</a><span className="mx-1"> > </span></span>
                    }
                    return <span className="font-weight-bold">{text}...</span>
                }):null}
            </div>
        </div>
       <div className="align-content-center">
           {children}
       </div>
    </div>
   </div>
}
